import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ChiTietDanhSachKiemKho } from "./ChiTietDanhSachKiemKho";

export const BtnChiTietKiemKho = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="chi tiết"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-thong-tin-iv2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ChiTietDanhSachKiemKho
          show={show}
          onHide={handleClose}
          bienbanId={item.Id}
        />
      )}
    </>
  );
};
